import { FunctionComponent as F, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { IState } from '../../core/store/store';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { ACCOUNT, LOGIN } from '../../core/router/paths';
import Button from '../../components/UI/Button/Button';
import { updatePassword } from '../../core/http/user';
import { validatePassword } from '../../utils/validate';
import { Dialog, DialogTitle, DialogContent } from '@mui/material';



const ChangePassword: F = () =>
{
  const navigate = useNavigate();
  const user = useSelector((state: IState) => state.user);
  const { key } = useParams<{ key: string }>();

  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState(false);
  const [password2, setPassword2] = useState("");
  const [password2Error, setPassword2Error] = useState(false);

  if(!user.username && !key)
  {
    navigate(LOGIN);
    return <></>;
  }

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setPassword(event.target.value);
    setPasswordError(!validatePassword(event.target.value));
    setPassword2Error(event.target.value !== password2);
  };

  const handlePassword2Change = (event: React.ChangeEvent<HTMLInputElement>) =>
  {
    setPassword2(event.target.value);
    setPassword2Error(event.target.value !== password);
  };

  async function handleSubmit()
  {
    if(password && password2 && !passwordError && !password2Error && user.userId)
      updatePassword(password, key).then(() => navigate(ACCOUNT));
  }


  return (
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      open={true}
      onClose={() => navigate(ACCOUNT)}>
      <DialogTitle sx={{ fontSize: '30px' }}>Change Password</DialogTitle>
      <DialogContent>
        <Stack
          direction='column'
          justifyContent='center'
          alignItems='center'
          spacing={2}>
          <TextField
            size='small'
            type='password'
            label='New password'
            value={password}
            onChange={handlePasswordChange}
            error={passwordError}/>
          <TextField
            size='small'
            type='password'
            label='Confirm password*'
            value={password2}
            onChange={handlePassword2Change}
            error={password2Error} />
          <Button
            label='Submit'
            onClick={() => handleSubmit()}/>
        </Stack>
      </DialogContent>
    </Dialog>);
};

export default ChangePassword;
